import modelBaseV2 from "../model-base-v2.model";

const ShipToModel = {
  getListShipToCode: function () {
    return modelBaseV2.get(`/api/shipto/list`);
  },
};

export default ShipToModel;
